<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    item-text="name"
    item-value="id"
    label="Инфо модель"
    no-data-text="Инфо модель не найдена"
    :request="request"
    v-on="$listeners"
  >
    <template #item="{ item }">
      <v-list-item-content>
        <v-list-item-title
          class="body-2 font-weight-regular"
          style="white-space: initial;"
          v-text="item.name"
        />
      </v-list-item-content>

      <v-list-item-icon v-if="item.application">
        <v-list-item-subtitle
          class="font-weight-regular grey--text text--lighten-1"
          v-text="item.application.code"
        />
      </v-list-item-icon>
    </template>
  </BAutocomplete>
</template>

<script>
import { openApiMixin } from './mixins'
import { PermissionsInfoModelsApi as Api } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


export default {
  name: 'BAutocompletePermissionInfoModel',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new Api()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(...args) {
      return this.adapter.getAll(...args)
    },
  },
}
</script>
